export default "__VITE_ASSET__Dr$72j72__"